var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12, _templateObject13, _templateObject14, _templateObject15, _templateObject16;

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

import { ARROW_SIZE, SPACING_FROM_NEAREST_CORNER } from './constants';
import { Shadows, getFocusStyles } from '@doordash/design-language';
import styled, { css } from 'styled-components';
import { AnchoredLayer } from '@doordash/component-layer-manager';
export var PopoverContainer = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  background: ", ";\n  border-radius: ", "px;\n  box-shadow: ", ";\n  display: flex;\n  align-items: flex-start;\n  overflow: auto;\n  outline: none;\n  &:focus {\n    ", ";\n  }\n"])), function (props) {
  return props.backgroundColor;
}, function (props) {
  return props.borderRadius;
}, Shadows.Large, getFocusStyles());
var ArrowStyle = css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral([""])));

var getStyleForPosition = function getStyleForPosition(_ref) {
  var backgroundColor = _ref.backgroundColor,
      position = _ref.position;

  switch (position) {
    case AnchoredLayer.Positions.TopLeft:
    case AnchoredLayer.Positions.TopCenter:
    case AnchoredLayer.Positions.TopRight:
      {
        var TRIANGLE = css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n        ", ";\n        border-left: ", "px solid transparent;\n        border-right: ", "px solid transparent;\n        border-top: ", "px solid ", ";\n        bottom: -", "px;\n      "])), ArrowStyle, ARROW_SIZE, ARROW_SIZE, ARROW_SIZE, backgroundColor, ARROW_SIZE);

        switch (position) {
          case AnchoredLayer.Positions.TopLeft:
          case AnchoredLayer.Positions.TopRight:
            return css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n            ", ";\n            ", ": ", "px;\n          "])), TRIANGLE, position === AnchoredLayer.Positions.TopLeft ? 'left' : 'right', SPACING_FROM_NEAREST_CORNER);

          case AnchoredLayer.Positions.TopCenter:
          default:
            return css(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n            ", ";\n            left: 0px;\n            right: 0px;\n          "])), TRIANGLE);
        }
      }

    case AnchoredLayer.Positions.RightTop:
    case AnchoredLayer.Positions.RightCenter:
    case AnchoredLayer.Positions.RightBottom:
      {
        var _TRIANGLE = css(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n        ", ";\n        border-top: ", "px solid transparent;\n        border-bottom: ", "px solid transparent;\n        border-right: ", "px solid ", ";\n        left: -", "px;\n      "])), ArrowStyle, ARROW_SIZE, ARROW_SIZE, ARROW_SIZE, backgroundColor, ARROW_SIZE);

        switch (position) {
          case AnchoredLayer.Positions.RightTop:
          case AnchoredLayer.Positions.RightBottom:
            return css(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n            ", ";\n            ", ": ", "px;\n          "])), _TRIANGLE, position === AnchoredLayer.Positions.RightTop ? 'top' : 'bottom', SPACING_FROM_NEAREST_CORNER * 1.5);

          case AnchoredLayer.Positions.TopCenter:
          default:
            return css(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n            ", ";\n            margin: auto;\n            top: 0px;\n            bottom: 0px;\n          "])), _TRIANGLE);
        }
      }

    case AnchoredLayer.Positions.LeftTop:
    case AnchoredLayer.Positions.LeftCenter:
    case AnchoredLayer.Positions.LeftBottom:
      {
        var _TRIANGLE2 = css(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n        ", ";\n        border-top: ", "px solid transparent;\n        border-bottom: ", "px solid transparent;\n        border-left: ", "px solid ", ";\n        right: -", "px;\n      "])), ArrowStyle, ARROW_SIZE, ARROW_SIZE, ARROW_SIZE, backgroundColor, ARROW_SIZE);

        switch (position) {
          case AnchoredLayer.Positions.LeftTop:
          case AnchoredLayer.Positions.LeftBottom:
            return css(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n            ", ";\n            ", ": ", "px;\n          "])), _TRIANGLE2, position === AnchoredLayer.Positions.LeftTop ? 'top' : 'bottom', SPACING_FROM_NEAREST_CORNER);

          case AnchoredLayer.Positions.TopCenter:
          default:
            return css(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n            ", ";\n            margin: auto;\n            top: 0px;\n            bottom: 0px;\n          "])), _TRIANGLE2);
        }
      }

    case AnchoredLayer.Positions.BottomLeft:
    case AnchoredLayer.Positions.BottomCenter:
    case AnchoredLayer.Positions.BottomRight:
      {
        var _TRIANGLE3 = css(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral(["\n        ", ";\n        border-left: ", "px solid transparent;\n        border-right: ", "px solid transparent;\n        border-bottom: ", "px solid ", ";\n        top: -", "px;\n      "])), ArrowStyle, ARROW_SIZE, ARROW_SIZE, ARROW_SIZE, backgroundColor, ARROW_SIZE);

        switch (position) {
          case AnchoredLayer.Positions.BottomLeft:
          case AnchoredLayer.Positions.BottomRight:
            return css(_templateObject13 || (_templateObject13 = _taggedTemplateLiteral(["\n            ", ";\n            ", ": ", "px;\n          "])), _TRIANGLE3, position === AnchoredLayer.Positions.BottomLeft ? 'left' : 'right', SPACING_FROM_NEAREST_CORNER * 1.5);

          case AnchoredLayer.Positions.BottomCenter:
          default:
            return css(_templateObject14 || (_templateObject14 = _taggedTemplateLiteral(["\n            ", ";\n            left: 0px;\n            right: 0px;\n          "])), _TRIANGLE3);
        }
      }

    default:
      return css(_templateObject15 || (_templateObject15 = _taggedTemplateLiteral([""])));
  }
};

export var Arrow = styled.div(_templateObject16 || (_templateObject16 = _taggedTemplateLiteral(["\n  width: 0;\n  height: 0;\n  position: absolute;\n  ", ";\n"])), getStyleForPosition);